const defaultTheme = {
    link: '#000e3e',
    fontFamily: '"Open Sans", Arial, Helvetica, sans-serif',
    hoverBackground: '#EEF6F7',
    AgentConversationBackground: '#e6e6e6',
    button: {
        primary: {
            text: '#FFFFFF',
            hover: '#2A5166',
        },
        secondary: {
            hover: '#EBF0F2',
        },
        text: '#34657F',
        background: '#34657F',
    },
    chatIcon: {
        background: '#34657F',
        outline: '#ffffff',
    },
    field: {
        icon: '#34657F',
        focus: '#34657F',
        label: '#34657F',
    },
    switch: {
        background: '#34657F',
    },
    checkbox: {
        background: '#34657F',
    },
    datepicker: {
        selectedDate: '#34657F',
        selectedDateText: '#FFFFFF',
    },
    radio: {
        inactiveBorder: '#000e3e',
        border: '#34657F',
        background: '#34657F',
        focusBackground: '#919296',
    },
    info: '#3e8529',
    danger: '#c63527',
    dangerHeader: '#212121',
    fontSizes: {
        default: '16px',
        headerText: '18px',
        promptText: '14px',
        subText: '12px',
    },
};
export default defaultTheme;
